import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedAdminRouteProps {
  children: React.ReactNode;
}

/**
 * 어드민 권한이 필요한 라우트를 보호하는 컴포넌트
 * - 로딩 중: 로딩 스피너 표시
 * - 비로그인: 로그인 페이지로 리다이렉트
 * - 일반 사용자: Dashboard로 리다이렉트 (권한 없음)
 * - 어드민: children 렌더링
 */
export default function ProtectedAdminRoute({ children }: ProtectedAdminRouteProps) {
  const { isAdmin, isAuthenticated, isLoading } = useAuth();

  // 로딩 중일 때
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          <p className="text-sm text-muted-foreground">인증 확인 중...</p>
        </div>
      </div>
    );
  }

  // 로그인하지 않은 경우
  if (!isAuthenticated) {
    return <Navigate to="/user/login" replace />;
  }

  // 어드민 권한이 없는 경우
  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  // 어드민 권한이 있는 경우
  return <>{children}</>;
}
